import { Component } from '@angular/core';

@Component({
  selector: 'app-parametros-cemento-page',
  templateUrl: './parametros-cemento-page.component.html',
  styleUrls: ['./parametros-cemento-page.component.css'],
})
export class ParametrosCementoPageComponent {}
